/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsResourceControllerRemoveMutationResponse, IntegrationsResourceControllerRemovePathParams, IntegrationsResourceControllerRemove401, IntegrationsResourceControllerRemove403, IntegrationsResourceControllerRemove404 } from "../../models/integrationsController/IntegrationsResourceControllerRemove";

function getIntegrationsResourceControllerRemoveUrl(id: IntegrationsResourceControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/integrations/${id}` as const }  
  return res
}

/**
 * @summary Disconnect an integration
 * {@link /api/v1/integrations/:id}
 */
export async function integrationsResourceControllerRemove(id: IntegrationsResourceControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationsResourceControllerRemoveMutationResponse, ResponseErrorConfig<IntegrationsResourceControllerRemove401 | IntegrationsResourceControllerRemove403 | IntegrationsResourceControllerRemove404>, unknown>({ method : "DELETE", url : getIntegrationsResourceControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}